var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from "@tanstack/react-query";
import { AUTH_HEADER } from "~/client/constants";
import { meResponseDecoder } from "~/client/decoders/meResponse";
import { throwAPIError } from "~/client/errors";
import useSafelyParseJsonResponse from "~/client/hooks/useSafelyParseJsonResponse";
import { getUserId } from "~/client/storage";
import fetch from "~/client/utils/fetch";
export const QUERY_KEY_PREFIX = "me";
export const getQueryKey = () => [QUERY_KEY_PREFIX];
const useGetMe = () => {
    const parseJson = useSafelyParseJsonResponse();
    return useQuery({
        queryKey: getQueryKey(),
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            const response = yield fetch("/me", {
                headers: {
                    [AUTH_HEADER]: (_a = getUserId()) !== null && _a !== void 0 ? _a : "",
                },
            });
            if (!response.ok) {
                yield throwAPIError(response);
            }
            const responseJson = yield parseJson(response);
            try {
                const me = meResponseDecoder.verify(responseJson);
                return me;
            }
            catch (_b) {
                throw new Error("Error fetching current user.");
            }
        }),
    });
};
export default useGetMe;
